import axios from "axios";
import React, { useEffect, useState } from "react";
import QuizChart from "./QuizChart";
import QuizBarChart from "./QuizBarChart";
import PieChartCate from "./PieChartsCate";
import {
  Card,
  CardContent,
  Grid,
  CircularProgress,
  Typography,
} from "@mui/material";
import StackedSubCat from "./StackedSubCat";

function NewScreen({ user }) {
  const [data, setData] = useState([]);
  const [subcatdata, setSubcatData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        `https://s3napi-dev.s3nsoftware.com/api/UserMasters/GetGraphByCategory?username=${user}`
      )
      .then((res) => setData(res.data))
      .catch((err) => console.error("Error fetching category data:", err))
      .finally(() => setLoading(false));
  }, [user]);

  useEffect(() => {
    axios
      .get(
        `https://s3napi-dev.s3nsoftware.com/api/UserMasters/GetGraphBySubCategory?username=${user}`
      )
      .then((res) => setSubcatData(res.data))
      .catch((err) => console.error("Error fetching subcategory data:", err));
  }, [user]);

  return (
    <Grid
      container
      spacing={3}
      sx={{ p: 3, minHeight: "100vh", justifyContent: "center" }}
    >
      {loading ? (
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "center", mt: 5 }}
        >
          <CircularProgress size={50} />
        </Grid>
      ) : data.length === 0 && subcatdata.length === 0 ? (
        <Grid item xs={12}>
          <Card
            sx={{ borderRadius: 3, boxShadow: 3, textAlign: "center", p: 3 }}
          >
            <Typography variant="h6" color="textSecondary">
              Looks like you haven't played any quizzes yet. Start now!
            </Typography>
          </Card>
        </Grid>
      ) : (
        <>
          {/* Quiz Line Chart */}
          <Grid item xs={12} sm={6}>
            <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
              <CardContent>
                {data.length > 0 ? (
                  <div style={{ width: "100%", height: 400 }}>
                    <QuizChart qdata={data} />
                  </div>
                ) : (
                  <Typography textAlign="center">
                    Quiz data not available.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Quiz Bar Chart */}
          <Grid item xs={12} sm={6}>
            <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
              <CardContent>
                {subcatdata.length > 0 ? (
                  <div style={{ width: "100%", height: 400 }}>
                    <QuizBarChart sdata={subcatdata} />
                  </div>
                ) : (
                  <Typography textAlign="center">
                    Quiz subcategory data not available.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Pie Chart */}
          <Grid item xs={12} sm={6}>
            <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
              <CardContent>
                {data.length > 0 ? (
                  <div style={{ width: "100%", height: 400 }}>
                    <PieChartCate cdata={data} />
                  </div>
                ) : (
                  <Typography textAlign="center">
                    Pie chart data not available.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Stacked SubCategory Chart */}
          <Grid item xs={12} sm={6}>
            <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
              <CardContent>
                {subcatdata.length > 0 ? (
                  <div style={{ width: "100%", height: 400 }}>
                    <StackedSubCat data={subcatdata} />
                  </div>
                ) : (
                  <Typography textAlign="center">
                    Stacked category data not available.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default NewScreen;
